import { MaterialReactTable } from "material-react-table";

export default function CurrencyTable({
  data,
  loading,
  onEdit,
  onDelete,
}) {
  const columns = [
    {
      accessorKey: "code",
      header: "Code",
    },
    {
      accessorKey: "symbol",
      header: "Symbol",
    },
    {
      accessorKey: "title",
      header: "Title",
    },
    {
      accessorKey: "status",
      header: "Status",
      Cell: ({ cell }) => (
        <span
          className={`rounded px-2 py-1 text-xs ${
            cell.getValue() === "active"
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
        >
          {cell.getValue()}
        </span>
      ),
    },
    {
      header: "Actions",
      Cell: ({ row }) => (
        <div className="flex gap-2">
          <button
            onClick={() => onEdit(row.original)}
            className="rounded bg-yellow-100 px-3 py-1 text-xs"
          >
            Edit
          </button>
          <button
            onClick={() => {
              if (
                window.confirm(
                  `Delete currency "${row.original.code}"?`
                )
              ) {
                onDelete(row.original);
              }
            }}
            className="rounded bg-red-100 px-3 py-1 text-xs"
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      state={{ isLoading: loading }}
      enableSorting={false}
      enableColumnFilters={false}
      enableGlobalFilter={false}
      muiTableBodyRowProps={{ hover: true }}
    />
  );
}
